import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 31,
	height: 30,
	viewBox: "0 0 31 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M30.9999 0.5H25.8109L25.4981 0.503178C24.5406 0.486811 24.1929 0.843858 23.9058 1.28472L19.8267 7.32464L15.9255 1.4062L15.7953 1.21219C15.7953 1.21219 15.689 1.03907 15.5021 1.03263H15.5009C15.3133 1.03907 15.207 1.21219 15.207 1.21219L15.0767 1.4062L11.3012 7.32464L7.0964 1.28472C6.80914 0.843858 6.46218 0.486811 5.50391 0.503178L5.19219 0.5H0.00204601L0 5.43175H3.05654C3.70108 5.42572 3.99852 5.45575 4.44007 5.986L4.62317 6.25414L10.791 15.9112C10.791 15.9112 10.9915 16.223 11.3322 16.225C11.6998 16.2262 11.9034 15.9104 11.9034 15.9104L15.5009 10.5222H15.5021L19.2372 15.9031C19.2372 15.9031 19.4478 16.2222 19.7649 16.2302C20.1054 16.2386 20.2934 15.9104 20.2934 15.9104L26.3798 6.25414L26.5615 5.986C26.8779 5.49182 27.2765 5.4401 27.9184 5.44614L30.9775 5.44415L30.9999 0.5Z",
		fill: "#F2B014"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M23.1745 14.2091L19.8476 19.4822L15.5651 13.2696L12.2658 18.2278L19.2188 29.1316C19.459 29.433 19.6495 29.4964 19.7461 29.4995C19.957 29.5088 20.079 29.3962 20.3059 29.0147L25.7668 19.0582C26.252 18.1933 27.0636 18.2045 27.0636 18.2045H31V13.2792H24.8538C23.7342 13.2792 23.1745 14.2091 23.1745 14.2091Z",
		fill: "#F2B014"
	})]
});
const ForwardRef = forwardRef(SvgLogo);
export default ForwardRef;
